"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const ProgressBar = ({ progress, style, children }) => {
    const containerStyle = Object.assign({ height: 24, display: 'flex', flexDirection: 'column', justifyContent: 'center' }, style.containerStyle);
    const barStyle = Object.assign({ overflow: 'hidden', width: 240, height: 12, backgroundColor: colors_1.cloud, borderRadius: 12 }, style.barStyle);
    const progressStyle = Object.assign({ backgroundColor: 'tomato', width: progress > 3 ? `${progress}%` : barStyle.height, height: '100%', borderRadius: 12 }, style.progressStyle);
    return (React.createElement("div", { style: containerStyle },
        React.createElement("div", { style: barStyle },
            React.createElement("div", { style: progressStyle }, children))));
};
exports.default = ProgressBar;
